<template>
    <div>
        <el-form :model="from" :rules="rules" ref="ruleForm" label-width="170px">
            <table style="width: 95%; margin: 0 2%; margin-top: 20px;">
                <tr>
                    <td style="height: 30px; width: 25%;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">入职类型：</span>
                            </template>
                            <el-select v-model="from.entry_type_id" placeholder="请选择入职类型" size="small" clearable
                                style="width: 100%;">
                                <el-option v-for="item in secondDegreeList" :key="item.id" :label="item.data"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td style="width: 25%;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">招聘方式：</span>
                            </template>
                            <el-select v-model="from.recruitment_method_id" placeholder="请选择招聘方式" size="small" clearable
                                style="width: 100%;">
                                <el-option v-for="item in secondDegreeList" :key="item.id" :label="item.data"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td style="width: 25%;">
                        <el-form-item prop="induction_time" style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">入职时间：</span>
                            </template>
                            <el-date-picker v-model="from.induction_time" type="date" placeholder="请选择入职时间"
                                style="width: 100%;" value-format="yyyy-MM-dd" size="small">
                            </el-date-picker>
                        </el-form-item>
                    </td>
                    <td style="width: 25%;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">工龄：</span>
                            </template>
                            <el-input placeholder="请输入工龄" v-model="from.working_age" size="small" type="number" readonly="readonly"
                                style="width: 100%;">
                            </el-input>
                        </el-form-item>
                    </td>
                </tr>

                <tr>
                    <td style="height: 30px;">
                        <el-form-item prop="induction_salary" style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">入职薪资：</span>
                            </template>
                            <el-input placeholder="请输入入职薪资" v-model="from.induction_salary" size="small"
                                style="width: 52%;" type="number"></el-input>
                            <el-button plain size="mini" style="margin-left: 10px;">薪资记录</el-button>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">入职添加时间：</span>
                            </template>
                            <el-date-picker v-model="from.induction_date" type="date" placeholder="请选择入职添加时间" readonly="readonly"
                                style="width: 100%;" value-format="yyyy-MM-dd" size="small">
                            </el-date-picker>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">离职添加时间：</span>
                            </template>
                            <el-date-picker v-model="from.quit_date" type="date" placeholder="请选择离职添加时间" readonly="readonly"
                                style="width: 100%;" value-format="yyyy-MM-dd" size="small">
                            </el-date-picker>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">籍贯：</span>
                            </template>
                            <el-input v-model="from.native_place" size="small" style="width: 100%;" readonly="readonly">
                            </el-input>
                        </el-form-item>
                    </td>
                </tr>

                <tr>
                    <td style="height: 30px;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">员工类别：</span>
                            </template>
                            <el-input v-model="from.staff_type" size="small" style="width: 100%;" readonly="readonly"
                                disabled>
                            </el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">加入集团日期：</span>
                            </template>
                            <el-date-picker v-model="from.induction_time" type="date" readonly="readonly"
                                style="width: 100%;" value-format="yyyy-MM-dd" size="small">
                            </el-date-picker>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">所属部门：</span>
                            </template>
                            <el-input v-model="from.project_name" size="small" disabled style="width: 100%;"></el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">试用期：</span>
                            </template>
                            <el-input placeholder="请输入试用期" v-model="from.probation_period" size="small" readonly="readonly"
                                style="width: 100%;"></el-input>
                        </el-form-item>
                    </td>
                </tr>

                <tr>
                    <td style="height: 30px;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">转正日期：</span>
                            </template>
                            <el-date-picker v-model="from.formal_date" type="date" placeholder="请选择转正日期" readonly="readonly"
                                style="width: 100%;" value-format="yyyy-MM-dd" size="small">
                            </el-date-picker>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item prop="post_id" style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">所在职位：</span>
                            </template>
                            <el-select v-model="from.post_id" placeholder="请选择所在职位" size="small" clearable
                                style="width: 100%;">
                                <el-option v-for="item in postList" :key="item.id" :label="item.post_name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">薪酬等级：</span>
                            </template>
                            <el-select v-model="from.pay_grade" placeholder="请选择薪酬等级" size="small" clearable
                                style="width: 100%;">
                                <el-option v-for="item in secondDegreeList" :key="item.id" :label="item.data"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">职级：</span>
                            </template>
                            <el-select v-model="from.rank" placeholder="请选择职级" size="small" clearable
                                style="width: 100%;">
                                <el-option v-for="item in secondDegreeList" :key="item.id" :label="item.data"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                </tr>

                <tr>
                    <td style="height: 30px;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">上级职位：</span>
                            </template>
                            <el-select v-model="from.we_chat" placeholder="请选择上级职位" size="small" clearable
                                style="width: 100%;">
                                <el-option v-for="item in secondDegreeList" :key="item.id" :label="item.data"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">上级名称：</span>
                            </template>
                            <el-select v-model="from.we_chat" placeholder="请选择上级名称" size="small" clearable
                                style="width: 100%;">
                                <el-option v-for="item in secondDegreeList" :key="item.id" :label="item.data"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">是否兼职：</span>
                            </template>
                            <el-radio v-model="from.is_part_time_job" label="1">是</el-radio>
                            <el-radio v-model="from.is_part_time_job" label="0">否</el-radio>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">项目经验表：</span>
                            </template>
                            <el-button plain size="mini">项目经验表</el-button>
                        </el-form-item>
                    </td>
                </tr>

                <tr>
                    <td style="height: 30px;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">现薪酬：</span>
                            </template>
                            <el-input placeholder="请输入现薪资" v-model="from.spare5" size="small"
                                style="width: 100%;" type="number"></el-input>
                        </el-form-item>
                    </td>
                </tr>
            </table>
        </el-form>
    </div>
</template>

<script>
    export default {
        props: ["from"],
        data() {
            return {

                //表单验证
                rules: {
                    induction_time: [{
                        required: true,
                        message: '请选择入职时间！',
                        trigger: 'blur'
                    }],
                    induction_salary: [{
                        required: true,
                        message: '请输入入职薪资！',
                        trigger: 'blur'
                    }],
                    post_id: [{
                        required: true,
                        message: '请选择所在职位！',
                        trigger: 'blur'
                    }],
                },

                //职位
                postList: [],
            }
        },
        async created() {
            //初始化职位
            var postList = await this.$globals.AxiosPost("post/selectFind", {});
            this.postList = postList.data;
        }
    }
</script>

<style scoped="scoped">
    >>>.el-button {
        border: 1px solid #006e48;
        color: #006e48;
    }

    >>>.el-button:hover {
        border: 1px solid #006e48;
        color: #006e48;
    }

    >>>.el-radio__input.is-checked .el-radio__inner {
        background-color: #006E4B;
        border-color: #006E4B;
    }

    >>>.el-radio__input.is-checked+.el-radio__label {
        color: #006E4B;
    }
</style>



// WEBPACK FOOTER //
// work.vue?633cf321